import * as React from "react"
import BasicLayout from "../../layouts/BasicLayout";
import Helmet from "react-helmet";
import PageTitle from "../../components/PageTitle";

const IndexPage: React.FC = () => (
    <BasicLayout>

        <Helmet title="react-imba-tables docs: Docs" defer={false} />

        <PageTitle title="Docs"/>

        <p>Coming soon...</p>

    </BasicLayout>
);

export default IndexPage;
